export const bankList = {
  banks: [
    {
      bank_code: "IOBA",
      icon: require("./../assets/images/bank/IOBA.png"),
      bank_name: "INDIAN OVERSEAS BANK",
    },
    {
      bank_code: "ABHY",
      icon: require("./../assets/images/bank/ABHY.png"),
      bank_name: "ABHYUDAYA CO-OPERATIVE BANK LTD",
    },
    {
      bank_code: "ABNA",
      icon: require("./../assets/images/bank/ABNA.png"),
      bank_name: "THE ROYAL BANK OF SCOTLAND",
    },
    {
      bank_code: "ALLA",
      icon: require("./../assets/images/bank/ALLA.png"),
      bank_name: "ALLAHABAD BANK",
    },
    {
      bank_code: "ANDB",
      icon: require("./../assets/images/bank/ANDB.png"),
      bank_name: "ANDHRA BANK",
    },
    {
      bank_code: "AUBL",
      icon: require("./../assets/images/bank/AUBL.png"),
      bank_name: "AU SMALL FINANCE BANK",
    },
    {
      bank_code: "BABO",
      icon: require("./../assets/images/bank/BABO.png"),
      bank_name: "BANK OF BARODA",
    },
    {
      bank_code: "BARB",
      icon: require("./../assets/images/bank/BARB.png"),
      bank_name: "BANK OF BARODA",
    },
    {
      bank_code: "BARC",
      icon: require("./../assets/images/bank/BARC.png"),
      bank_name: "BARCLAYS BANK",
    },
    {
      bank_code: "BDBL",
      icon: require("./../assets/images/bank/BDBL.png"),
      bank_name: "BANDHAN BANK LIMITED - WH",
    },
    {
      bank_code: "BHID",
      icon: require("./../assets/images/bank/BHID.png"),
      bank_name: "BANK OF INDIA",
    },
    {
      bank_code: "BKDN",
      icon: require("./../assets/images/bank/BKDN.png"),
      bank_name: "DENA BANK",
    },
    {
      bank_code: "BKID",
      icon: require("./../assets/images/bank/BKID.png"),
      bank_name: "BANK OF INDIA",
    },
    {
      bank_code: "BKID",
      icon: require("./../assets/images/bank/BKID.png"),
      bank_name: "BANK OF INDIA",
    },
    {
      bank_code: "BNPA",
      icon: require("./../assets/images/bank/BNPA.png"),
      bank_name: "BNP PARIBAS",
    },
    {
      bank_code: "CBIN",
      icon: require("./../assets/images/bank/CBIN.png"),
      bank_name: "CENTRAL BANK OF INDIA",
    },
    {
      bank_code: "CITI",
      icon: require("./../assets/images/bank/CITI.png"),
      bank_name: "CITI BANK",
    },
    {
      bank_code: "CIUB",
      icon: require("./../assets/images/bank/CIUB.png"),
      bank_name: "CITY UNION BANK LTD",
    },
    {
      bank_code: "CNRB",
      icon: require("./../assets/images/bank/CNRB.png"),
      bank_name: "CANARA BANK",
    },
    {
      bank_code: "CORP",
      icon: require("./../assets/images/bank/CORP.png"),
      bank_name: "CORPORATION  BANK",
    },
    {
      bank_code: "CORP",
      icon: require("./../assets/images/bank/CORP.png"),
      bank_name: "CORPORATION BANK",
    },
    {
      bank_code: "COSB",
      icon: require("./../assets/images/bank/COSB.png"),
      bank_name: "THE COSMOS CO-OP BANK LTD",
    },
    {
      bank_code: "COSB",
      icon: require("./../assets/images/bank/COSB.png"),
      bank_name: "THE COSMOS CO.OP BANK LTD",
    },
    {
      bank_code: "CSBK",
      icon: require("./../assets/images/bank/CSBK.png"),
      bank_name: "CATHOLIC SYRIAN BANK LTD",
    },
    {
      bank_code: "DBSS",
      icon: require("./../assets/images/bank/DBSS.png"),
      bank_name: "DBS BANK",
    },
    {
      bank_code: "ANDB",
      icon: require("./../assets/images/bank/ANDB.png"),
      bank_name: "ANDHRA BANK-HYDERABAD",
    },
    {
      bank_code: "DCBL",
      icon: require("./../assets/images/bank/DCBL.png"),
      bank_name: "DEVELOPMENT CREDIT BANK",
    },
    {
      bank_code: "DEUT",
      icon: require("./../assets/images/bank/DEUT.png"),
      bank_name: "DEUTSCHE BANK",
    },
    {
      bank_code: "DLXB",
      icon: require("./../assets/images/bank/DLXB.png"),
      bank_name: "DHANLAXMI BANK LIMITED",
    },
    {
      bank_code: "FDRL",
      icon: require("./../assets/images/bank/FDRL.png"),
      bank_name: "FEDERAL BANK LIMITED",
    },
    {
      bank_code: "FIRN",
      icon: require("./../assets/images/bank/FIRN.png"),
      bank_name: "FRIST RAND BANK",
    },
    {
      bank_code: "GBCB",
      icon: require("./../assets/images/bank/GBCB.png"),
      bank_name: "THE GREATER BOMBAY CO-OP",
    },
    {
      bank_code: "HDFC",
      icon: require("./../assets/images/bank/HDFC.png"),
      bank_name: "ABN AMRO BANK",
    },
    {
      bank_code: "HDFC",
      icon: require("./../assets/images/bank/HDFC.png"),
      bank_name: "HDFC BANK",
    },
    {
      bank_code: "HSBC",
      icon: require("./../assets/images/bank/HSBC.png"),
      bank_name: "HSBC BANK",
    },
    {
      bank_code: "IBKL",
      icon: require("./../assets/images/bank/IBKL.png"),
      bank_name: "IDBI BANK LTD",
    },
    {
      bank_code: "ICIC",
      icon: require("./../assets/images/bank/ICIC.png"),
      bank_name: "ICICI BANK",
    },
    {
      bank_code: "IDFB",
      icon: require("./../assets/images/bank/IDFB.png"),
      bank_name: "IDFC BANK",
    },
    {
      bank_code: "IDIB",
      icon: require("./../assets/images/bank/IDIB.png"),
      bank_name: "INDIAN BANK",
    },
    {
      bank_code: "INDB",
      icon: require("./../assets/images/bank/INDB.png"),
      bank_name: "INDUSIND BANK",
    },
    {
      bank_code: "IOBA",
      icon: require("./../assets/images/bank/IOBA.png"),
      bank_name: "INDIAN OVERSEAS BANK",
    },
    {
      bank_code: "JAKA",
      icon: require("./../assets/images/bank/JAKA.png"),
      bank_name: "THE JAMMU AND KASMIR BANK",
    },
    {
      bank_code: "JSBP",
      icon: require("./../assets/images/bank/JSBP.png"),
      bank_name: "JANATA SAHAKARI BANK LTD",
    },
    {
      bank_code: "KARB",
      icon: require("./../assets/images/bank/KARB.png"),
      bank_name: "KARNATAKA BANK LTD",
    },
    {
      bank_code: "KKBK",
      icon: require("./../assets/images/bank/KKBK.png"),
      bank_name: "KOTAK  MAHINDRA BANK",
    },
    {
      bank_code: "KVBL",
      icon: require("./../assets/images/bank/KVBL.png"),
      bank_name: "KARUR VYSYA BANK",
    },
    {
      bank_code: "LAVB",
      icon: require("./../assets/images/bank/LAVB.png"),
      bank_name: "LAKSHMI VILAS BANK",
    },
    {
      bank_code: "MAHB",
      icon: require("./../assets/images/bank/MAHB.png"),
      bank_name: "BANK OF MAHARASHTRA",
    },
    {
      bank_code: "BKDN",
      icon: require("./../assets/images/bank/BKDN.png"),
      bank_name: "DENA BANK",
    },
    {
      bank_code: "MHCB",
      icon: require("./../assets/images/bank/MHCB.png"),
      bank_name: "MIZUHO BANK LTD",
    },
    {
      bank_code: "MHCB",
      icon: require("./../assets/images/bank/MHCB.png"),
      bank_name: "MIZUHO BANK, LTD",
    },
    {
      bank_code: "NKGS",
      icon: require("./../assets/images/bank/NKGS.png"),
      bank_name: "N.K.G.S.B.CO-OP.BANK LTD.",
    },
    {
      bank_code: "ORBC",
      icon: require("./../assets/images/bank/ORBC.png"),
      bank_name: "ORIENTAL BANK OF COMMERCE",
    },
    {
      bank_code: "PMCB",
      icon: require("./../assets/images/bank/PMCB.png"),
      bank_name: "PUNJAB AND MAHARASHTRA CO BANK",
    },
    {
      bank_code: "PSIB",
      icon: require("./../assets/images/bank/PSIB.png"),
      bank_name: "PUNJAB & SIND BANK",
    },
    {
      bank_code: "PUNB",
      icon: require("./../assets/images/bank/PUNB.png"),
      bank_name: "DENA BANK",
    },
    {
      bank_code: "PUNB",
      icon: require("./../assets/images/bank/PUNB.png"),
      bank_name: "PUNJAB NATIONAL BANK",
    },
    {
      bank_code: "RATN",
      icon: require("./../assets/images/bank/RATN.png"),
      bank_name: "RATNAKAR BANK LIMITED",
    },
    {
      bank_code: "ABHY",
      icon: require("./../assets/images/bank/ABHY.png"),
      bank_name: "ABHYUDAYA CO OP BANK",
    },
    {
      bank_code: "SBBJ",
      icon: require("./../assets/images/bank/SBBJ.png"),
      bank_name: "STATE BANK OF BIKANER & JAIPUR",
    },
    {
      bank_code: "SBHY",
      icon: require("./../assets/images/bank/SBHY.png"),
      bank_name: "STATE BANK OF HYDERABAD",
    },
    {
      bank_code: "SBIN",
      icon: require("./../assets/images/bank/SBIN.png"),
      bank_name: "STATE BANK OF INDIA",
    },
    {
      bank_code: "SBMY",
      icon: require("./../assets/images/bank/SBMY.png"),
      bank_name: "STATE BANK OF INDIA",
    },
    {
      bank_code: "SBMY",
      icon: require("./../assets/images/bank/SBMY.png"),
      bank_name: "STATE BANK OF MYSORE",
    },
    {
      bank_code: "SBTR",
      icon: require("./../assets/images/bank/SBTR.png"),
      bank_name: "STATE BANK OF TRAVANCORE",
    },
    {
      bank_code: "SCBL",
      icon: require("./../assets/images/bank/SCBL.png"),
      bank_name: "STANDARD CHARTED BANK",
    },
    {
      bank_code: "SIBL",
      icon: require("./../assets/images/bank/SIBL.png"),
      bank_name: "SOUTH INDIAN BANK LTD",
    },
    {
      bank_code: "SIBL",
      icon: require("./../assets/images/bank/SIBL.png"),
      bank_name: "THE SOUTH INDIAN BANK LIMITED",
    },
    {
      bank_code: "SRCB",
      icon: require("./../assets/images/bank/SRCB.png"),
      bank_name: "SARASWAT BANK",
    },
    {
      bank_code: "STBP",
      icon: require("./../assets/images/bank/STBP.png"),
      bank_name: "STATE BANK OF PATIALA",
    },
    {
      bank_code: "SUTB",
      icon: require("./../assets/images/bank/SUTB.png"),
      bank_name: "THE SUTEX CO-OP BANK LTD",
    },
    {
      bank_code: "SVCB",
      icon: require("./../assets/images/bank/SVCB.png"),
      bank_name: "THE SHAMRAO VITHAL CO OP BANK LTD",
    },
    {
      bank_code: "SYNB",
      icon: require("./../assets/images/bank/SYNB.png"),
      bank_name: "SYNDICATE BANK",
    },
    {
      bank_code: "TMBL",
      icon: require("./../assets/images/bank/TMBL.png"),
      bank_name: "TAMILNAD MERCANTILE BANK",
    },
    {
      bank_code: "UBIN",
      icon: require("./../assets/images/bank/UBIN.png"),
      bank_name: "UNION BANK OF INDIA",
    },
    {
      bank_code: "UCBA",
      icon: require("./../assets/images/bank/UCBA.png"),
      bank_name: "UCO BANK",
    },
    {
      bank_code: "UJVN",
      icon: require("./../assets/images/bank/UJVN.png"),
      bank_name: "UJJIVAN SMALL FINANCE BANK",
    },
    {
      bank_code: "UTBI",
      icon: require("./../assets/images/bank/UTBI.png"),
      bank_name: "UNITED BANK OF INDIA",
    },
    {
      bank_code: "UTIB",
      icon: require("./../assets/images/bank/UTIB.png"),
      bank_name: "AXIS BANK",
    },
    {
      bank_code: "VARA",
      icon: require("./../assets/images/bank/VARA.png"),
      bank_name: "THE VARACHHA CO OPERATIVE",
    },
    {
      bank_code: "VIJB",
      icon: require("./../assets/images/bank/VIJB.png"),
      bank_name: "VIJAYA BANK",
    },
    {
      bank_code: "VYSA",
      icon: require("./../assets/images/bank/VYSA.png"),
      bank_name: "ING VYSYA BANK",
    },
    {
      bank_code: "VYSA",
      icon: require("./../assets/images/bank/VYSA.png"),
      bank_name: "ING VYSYA BANK LIMITED",
    },
    {
      bank_code: "VYSA",
      icon: require("./../assets/images/bank/VYSA.png"),
      bank_name: "ING VYSYA BANK LTD",
    },
    {
      bank_code: "YESB",
      icon: require("./../assets/images/bank/YESB.png"),
      bank_name: "YES BANK",
    },
  ],
};
